export default function Hero() {
  return (
    <section id="home" className="relative h-screen">
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage:
            "url(https://images.pexels.com/photos/356036/pexels-photo-356036.jpeg?auto=compress&cs=tinysrgb&w=1920)",
        }}
      >
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/50 to-black/70"></div>
      </div>

      <div className="relative h-full flex items-center justify-center">
        <div className="max-w-4xl mx-auto px-4 text-center">
          <h1 className="text-5xl md:text-7xl font-bold text-white mb-6 leading-tight">
            Top Solar and
            <br />
            Renewable Energy
          </h1>
          <p className="text-lg md:text-xl text-white/90 mb-8 max-w-2xl mx-auto">
            Vero elit justo olla dolor at sed diam no Kasd rebun ipsum et diam
            justo clita et kasd rebun sea elitr
          </p>
          <button className="px-8 py-4 bg-orange-500 text-white rounded-full font-medium text-lg hover:bg-orange-600 transition-all duration-300 hover:shadow-xl hover:scale-105">
            Read More
          </button>

          <div className="flex justify-center items-center space-x-3 mt-12">
            <div className="w-12 h-1 bg-white rounded-full"></div>
            <div className="w-3 h-3 bg-white/50 rounded-full"></div>
            <div className="w-3 h-3 bg-white/50 rounded-full"></div>
          </div>
        </div>
      </div>
    </section>
  );
}
